//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// material-ui
import { makeStyles } from "@material-ui/core/styles";
import { withStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";

export const NoDataStyles = makeStyles({
  emptyDataText: {
    textAlign: "center",
    fontSize: 20,
    fontFamily: "segoe-ui",
    padding: "5%",
  },
  emptyDataIcon: {
    fontSize: 30,
  },
  "makeStyles-emptyDataText": {},
  errorMsg: {
    color: "#606060",
  },
});

export const useRowStyles = makeStyles({
  tableHeader: {
    background: "#EDEDED",
    boxShadow:
      "rgb(112 112 112 / 60%) 0px 1.5px 4px 0px inset, rgb(112 112 112 / 60%) 0.5px 0px 1px 0px, rgb(255 255 255) 0px -4px 0px 0px inset, rgb(112 112 112 / 60%) 0.5px 0px 0px 0px",
  },
  heading: {
    fontSize: 16,
    fontWeight: "bold",
    borderBottom: "none",
    padding: 5,
    textAlign: "left !important",
  },
  subHeading: {
    fontSize: 16,
    fontWeight: "bold",
    color: "#707070",
    borderBottom: "none",
    textAlign: "center",
  },
  data: {
    fontSize: "0.875rem",
    borderBottom: "none",
    padding: "4px 5px",
  },
  subData: {
    color: "#707070",
    fontSize: 20,
    borderBottom: "none",
    padding: "8px 16px",
  },
  cells: {
    fontSize: "0.875rem",
    color: "#000000",
    padding: 5,
    // fontWeight: "bold",
    textAlign: "left !important",
  },
  sortIcon: {
    verticalAlign: "sub",
    fontSize: 18,
    cursor: "pointer",
  },
  IconButton: {
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  collapseText: {
    cursor: "pointer",
  },
  tableRow: {
    // backgroundColor: "aliceblue",
  },
  tableHeader: {
    background: "#EDEDED",
    // boxShadow: "rgb(112 112 112 / 60%) 0px 1.5px 4px 0px inset, rgb(112 112 112 / 60%) 0.5px 0px 1px 0px, rgb(255 255 255) 0px -4px 0px 0px inset, rgb(112 112 112 / 60%) 0.5px 0px 0px 0px",
  },
  heading: {
    fontSize: "0.875rem",
    fontWeight: "bold",
    borderBottom: "none",
    padding: 5,
    textAlign: "left !important",
    fontFamily: "segoe-ui",
  },
  subHeading: {
    fontSize: "0.875rem",
    fontWeight: "bold",
    color: "#707070",
    borderBottom: "none",
    textAlign: "center",
  },
  data: {
    fontSize: "0.875rem",
    borderBottom: "none",
    padding: "4px 5px",
  },
  subData: {
    color: "#707070",
    fontSize: 20,
    borderBottom: "none",
    padding: "8px 16px",
  },
  cells: {
    fontSize: "0.875rem",
    color: "#2F7CBD",
    padding: "5px 16px ",
    fontWeight: "bold",
    textAlign: "left !important",
  },
  sortIcon: {
    verticalAlign: "sub",
    fontSize: 18,
    cursor: "pointer",
  },
  IconButton: {
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  collapseText: {
    cursor: "pointer",
  },
  tableRow: {
    backgroundColor: "aliceblue",
  },
});

export const collapseComponentStyles = makeStyles({
  heading: {
    fontSize: 15,
    fontWeight: "bold",
    borderBottom: "none",
    textAlign: "center",
  },
  subHeading: {
    fontSize: "0.875rem",
    fontWeight: "bold",
    color: "#000",
    borderBottom: "none",
    padding: 5,
    textAlign: "center",
  },
  data: {
    fontSize: "0.875rem",
    borderBottom: "none",
  },
  subData: {
    color: "#2f7cbd",
    fontSize: "0.875rem",
    borderBottom: "none",
    padding: 5,
    textAlign: "center!important",
  },
  tabelCell: {
    padding: "0px !important",
    borderBottom: "none !important",
  },
  tableRow: {
    backgroundColor: "rgb(228 228 228 / 30%)",
  },
});

export const tableStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  tableHeader: {
    background: "#EDEDED",
    boxShadow:
      "rgb(112 112 112 / 60%) 0px 1.5px 4px 0px inset, rgb(112 112 112 / 60%) 0.5px 0px 1px 0px, rgb(255 255 255) 0px -4px 0px 0px inset, rgb(112 112 112 / 60%) 0.5px 0px 0px 0px",
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
  tableHead: {
    background: "#EDEDED",
    // boxShadow: "rgb(112 112 112 / 60%) 0px 1.5px 4px 0px inset, rgb(112 112 112 / 60%) 0.5px 0px 1px 0px, rgb(255 255 255) 0px -4px 0px 0px inset, rgb(112 112 112 / 60%) 0.5px 0px 0px 0px",
  },
  tableHeading: {
    color: "#000",
    fontWeight: "bold",
    fontSize: "0.875rem",
    fontFamily: "segoe-ui",
    padding: 5,
    width: "0px",
  },
  tabelCell: {
    fontSize: "0.875rem",
    fontFamily: "segoe-ui",
    padding: "5px",
    borderBottom: "none",
  },
  pagination: {
    float: "left",
    padding: 0,
  },
  arrowIcon: {
    verticalAlign: "sub",
    fontSize: 18,
    cursor: "pointer",
  },
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  tableHeader: {
    background: "#EDEDED",
    boxShadow:
      "rgb(112 112 112 / 60%) 0px 1.5px 4px 0px inset, rgb(112 112 112 / 60%) 0.5px 0px 1px 0px, rgb(255 255 255) 0px -4px 0px 0px inset, rgb(112 112 112 / 60%) 0.5px 0px 0px 0px",
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
  tableHead: {
    background: "#EDEDED",
    // boxShadow: "rgb(112 112 112 / 60%) 0px 1.5px 4px 0px inset, rgb(112 112 112 / 60%) 0.5px 0px 1px 0px, rgb(255 255 255) 0px -4px 0px 0px inset, rgb(112 112 112 / 60%) 0.5px 0px 0px 0px",
  },
  tabelCell: {
    fontSize: "0.875rem",
    fontFamily: "segoe-ui !important",
    padding: "5px",
    borderBottom: "none",
  },
  pagination: {
    padding: 0,
    marginTop: 30,
  },
  arrowIcon: {
    verticalAlign: "sub",
    fontSize: 18,
    cursor: "pointer",
  },
}));

export const GreenCheckbox = withStyles({
  root: {
    color: "#707070",
    "&$checked": {
      color: green[600],
    },
  },
  checked: {},
});
